import { useCallback, useRef } from "react";

interface CarouselScrollAnalyticsProps {
  onScroll?: (scrollDirection?: string) => void;
  debounceMs?: number;
}

export const useCarouselScrollAnalytics = ({
  onScroll, 
  debounceMs = 300 
}: CarouselScrollAnalyticsProps) => {
  const timeoutRef = useRef<NodeJS.Timeout | null>(null);
  const lastDirectionRef = useRef<string | undefined>(undefined);

  const triggerScrollAnalytics = useCallback(
    (direction?: string) => {
      if (!onScroll) return;

      lastDirectionRef.current = direction;

      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }

      timeoutRef.current = setTimeout(() => {
        onScroll(lastDirectionRef.current);
      }, debounceMs);
    },
    [onScroll, debounceMs]
  );

  const handleScrollLeft = useCallback(() => {
    triggerScrollAnalytics("left");
  }, [triggerScrollAnalytics]);

  const handleScrollRight = useCallback(() => {
    triggerScrollAnalytics("right");
  }, [triggerScrollAnalytics]);

  const handleManualScroll = useCallback(() => {
    triggerScrollAnalytics(lastDirectionRef.current);
  }, [triggerScrollAnalytics]);

  return {
    handleScrollLeft,
    handleScrollRight,
    handleManualScroll,
  };
};